export default "__VITE_ASSET__DrzAUff3__"